/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { UserCurrentRetrieveStatus200, UserCurrentRetrieveStatus401 } from "../types/UserCurrentRetrieve.ts";
import type { QueryKey, QueryClient, UseQueryOptions, UseQueryReturnType } from "@tanstack/vue-query";
import { userCurrentRetrieve } from "../requests/userCurrentRetrieve.ts";
import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";

export const userCurrentRetrieveQueryKey = () => [{ url: "/api/user/current" }] as const;

export type UserCurrentRetrieveQueryKey = ReturnType<typeof userCurrentRetrieveQueryKey>;

export function userCurrentRetrieveQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {
	const queryKey = userCurrentRetrieveQueryKey();
	return queryOptions<UserCurrentRetrieveStatus200, ResponseErrorConfig<UserCurrentRetrieveStatus401>, UserCurrentRetrieveStatus200>({
		queryKey,
		queryFn: async ({ signal }) => {
			return userCurrentRetrieve({ ...config, signal: config.signal ?? signal });
		},
	});
}

/**
 * @description Текущий пользователь.
 * @summary текущий пользователь
 * {@link /api/user/current}
 */
export function useUserCurrentRetrieve<
	TData = UserCurrentRetrieveStatus200,
	TQueryData = UserCurrentRetrieveStatus200,
	TQueryKey extends QueryKey = UserCurrentRetrieveQueryKey,
>(
	options: {
		query?: Partial<UseQueryOptions<UserCurrentRetrieveStatus200, ResponseErrorConfig<UserCurrentRetrieveStatus401>, TData, TQueryData, TQueryKey>> & {
			client?: QueryClient;
		};
		client?: Partial<RequestConfig> & { client?: Client };
	} = {},
) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const queryKey = (resolvedOptions && "queryKey" in resolvedOptions ? toValue(resolvedOptions.queryKey) : undefined) ?? userCurrentRetrieveQueryKey();

	const query = useQuery(
		{
			...userCurrentRetrieveQueryOptions(config),
			...resolvedOptions,
			queryKey,
		} as unknown as UseQueryOptions<
			UserCurrentRetrieveStatus200,
			ResponseErrorConfig<UserCurrentRetrieveStatus401>,
			TData,
			UserCurrentRetrieveStatus200,
			TQueryKey
		>,
		toValue(queryClient),
	) as UseQueryReturnType<TData, ResponseErrorConfig<UserCurrentRetrieveStatus401>> & { queryKey: TQueryKey };

	query.queryKey = queryKey as TQueryKey;

	return query;
}
